module.exports = __webpack_public_path__ + "img/1.6c558fe6.jpg";